import { Link } from "react-router-dom";
import { MapPin, Calendar, ArrowUpRight } from "lucide-react";
import { inr, fmtDate } from "../lib/api";

export const EventCard = ({ event, index = 0 }) => (
  <Link
    to={`/events/${event.slug}`}
    data-testid={`event-card-${event.slug}`}
    className="group grid grid-cols-1 md:grid-cols-12 gap-0 border border-ink/15 bg-cream hover:border-terracotta transition-colors duration-300 overflow-hidden"
  >
    <div className="md:col-span-4 relative overflow-hidden aspect-video md:aspect-auto md:min-h-[240px]">
      <img
        src={event.image}
        alt={event.title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms] ease-out"
      />
    </div>

    <div className="md:col-span-8 p-6 md:p-9 flex flex-col justify-between border-l-2 md:border-l-2 border-terracotta">
      <div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-muted-earth text-xs uppercase tracking-[0.12em] mb-4">
          <span className="flex items-center gap-1.5"><Calendar size={13} /> {fmtDate(event.date)}</span>
          <span className="flex items-center gap-1.5"><MapPin size={13} /> {event.city}</span>
          <span className="text-terracotta">{event.spots_left} spots left</span>
        </div>
        <h3 className="font-serif text-3xl md:text-4xl font-light text-ink leading-tight mb-3">{event.title}</h3>
        <p className="text-muted-earth font-light leading-relaxed max-w-xl">{event.short_desc}</p>
      </div>

      <div className="flex items-center justify-between mt-7">
        <span className="font-serif text-2xl text-ink">{inr(event.price)} <span className="text-sm text-muted-earth font-sans">/ ticket</span></span>
        <span className="flex items-center gap-1 text-xs uppercase tracking-[0.15em] text-terracotta group-hover:gap-2.5 transition-all">
          Get Ticket <ArrowUpRight size={15} />
        </span>
      </div>
    </div>
  </Link>
);
